import script from "./CatalogServiceDeleteModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogServiceDeleteModal.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogServiceDeleteModal.vue?vue&type=style&index=0&id=74c88af4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74c88af4"]])

export default __exports__